import * as Yup from 'yup';
import { descriptionOptional, nameRequired, numberRequired } from '.';

export const stageSchema = Yup.object({
    stage_name: nameRequired,
    pipeline_id: Yup.number().moreThan(0, 'Pipeline not selected yet')
        .required('Deal Required'),
    days_due: numberRequired,
    description: descriptionOptional
});